/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：378
 */

"use strict"

function r() {
  return !("undefined" === typeof window || !window.document || !window.document.createElement)
}
export { r as a }
export default r
